import ApiService from "./apiService";
import {
  LOGIN_ENDPOINT,
  SIGNUP_ENDPOINT,
  EMAIL_VERIFICATION_ENDPOINT,
  FORGET_PASSWORD,
  RESEND_EMAIL,
  TOKEN_VERIFY,
  POST_RESET_PASSWORD,
  SUBSCRIBE_NEWSLETTER,
  UNSUBSCRIBE_NEWSLETTER,
  SEND_SIGNUP_OTP,
  VERIFY_SIGNUP_OTP,
  RESEND_SIGNUP_OTP,
} from "../constants/apiEndpoints";
import { throwServiceError } from "../utils/serviceError";
import { toast } from "react-toastify";

export const login = async (data) => {
  try {
    const response = await ApiService.post(LOGIN_ENDPOINT, data);
    return response;
  } catch (error) {
    toast.dismiss();
    throwServiceError(error, {
      message: "Login failed",
      code: "AUTH_ERROR",
      status: 401,
    });
  }
};

export const signup = async (data, captchaToken) => {
  try {
    const headers = captchaToken ? { "g-recaptcha-response": captchaToken } : {};
    const response = await ApiService.post(SIGNUP_ENDPOINT, data, headers);
    return response;
  } catch (error) {
     toast.dismiss();
    throwServiceError(error, {
      message: "Signup failed",
      code: "AUTH_ERROR",
      status: 400,
    });
  }
};

export const emailVerification = async (data) => {
  try {
    const response = await ApiService.post(EMAIL_VERIFICATION_ENDPOINT, data);
    return response;
  } catch (error) {
     toast.dismiss();
    throwServiceError(error, {
      message: "Email verification failed",
      code: "AUTH_ERROR",
      status: 400,
    });
  }
};

export const forgotPassword = async (data) => {
  try {
    const response = await ApiService.post(FORGET_PASSWORD, data);
    return response;
  } catch (error) {
     toast.dismiss();
    throwServiceError(error, {
      message: "Forgot password request failed",
      code: "AUTH_ERROR",
      status: 400,
    });
  }
};

export const resendVerificationEmail = async (data) => {
  try {
    const response = await ApiService.post(RESEND_EMAIL, data);
    return response;
  } catch (error) {
     toast.dismiss();
    throwServiceError(error, {
      message: "Resend verification email failed",
      code: "AUTH_ERROR",
      status: 400,
    });
  }
};

export const postResetPassword = async (data) => {
  try {
    const response = await ApiService.post(POST_RESET_PASSWORD, data);
    return response;
  } catch (error) {
     toast.dismiss();
    throwServiceError(error, {
      message: "Reset password submission failed",
      code: "AUTH_ERROR",
      status: 400,
    });
  }
};

export const resetPassword = async (data) => {
  try {
    const response = await ApiService.post(TOKEN_VERIFY, data);
    return response;
  } catch (error) {
    toast.dismiss();
    throwServiceError(error, {
      message: "Reset token verification failed",
      code: "AUTH_ERROR",
      status: 400,
    });
  }
};

export const subscribeNewsletter = async (data) => {
  try {
    const response = await ApiService.post(SUBSCRIBE_NEWSLETTER, data);
    return response;
  } catch (error) {
     toast.dismiss();
    throwServiceError(error, {
      message: "Newsletter subscription failed",
      code: "NEWSLETTER_ERROR",
      status: 400,
    });
  }
};
export const unsubscribeNewsletter = async (data) => {
  try {
    const response = await ApiService.post(UNSUBSCRIBE_NEWSLETTER, data);
    return response;
  } catch (error) {
     toast.dismiss();
    throwServiceError(error, {
      message: "Newsletter unsubscribe failed",
      code: "NEWSLETTER_ERROR",
      status: 400,
    });
  }
};

export const sendSignupOTP = async (data) => {
  try {
    const response = await ApiService.post(SEND_SIGNUP_OTP, data);
    return response;
  } catch (error) {
     toast.dismiss();
    throwServiceError(error, {
      message: "Sending signup OTP failed",
      code: "AUTH_ERROR",
      status: 400,
    });
  }
};

export const verifySignupOTP = async (data) => {
  try {
    const response = await ApiService.post(VERIFY_SIGNUP_OTP, data);
    return response;
  } catch (error) {
     toast.dismiss();
    throwServiceError(error, {
      message: "Signup OTP verification failed",
      code: "AUTH_ERROR",
      status: 400,
    });
  }
};

export const resendSignupOTP = async (data) => {
  try {
    const response = await ApiService.post(RESEND_SIGNUP_OTP, data);
    return response;
  } catch (error) {
     toast.dismiss();
    throwServiceError(error, {
      message: "Resending signup OTP failed",
      code: "AUTH_ERROR",
      status: 400,
    });
  }
};

